// extracted by mini-css-extract-plugin
module.exports = {"heading":"_2IiwY","button-container":"_3PVk_"};